// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Button from '../../../../components/buttons/Button';
import Icon from '../../../../components/icons/Icon';

// Styles
import './SettingImageButton.scss';

const SettingImageButton = (props) => {
    const { label, imageSrc, recommended, disabled, selected, onClick, className, showUnselected, outlineSrc } = props;

    return (
        <Button className={classNames('SettingImageButton', className, { selected, disabled })} onClick={onClick}>
            <div className="icon-container">
                <img className="icon" src={imageSrc} />
                {outlineSrc && <img className="icon outline" src={outlineSrc} />}
            </div>
            <div className="label">
                {label} {recommended && <span className="default">(Recommended)</span>}
            </div>
            {selected && <Icon name="green-tick" />}
            {showUnselected && !selected && <Icon name="green-tick-empty" />}
        </Button>
    );
};

SettingImageButton.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    imageSrc: PropTypes.string,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    recommended: PropTypes.bool,
    showUnselected: PropTypes.bool,
    onClick: PropTypes.func,
    outlineSrc: PropTypes.string,
};

export default SettingImageButton;
